import { motion, useScroll, useTransform } from "framer-motion";
import { useRef,useEffect } from "react";
import {
  FaArrowRight,
  FaShieldAlt, FaLink, FaBrain, FaGlobe, FaMobileAlt, FaChartBar,
  FaCheckCircle,
} from "react-icons/fa";
import { SiBlockchaindotcom } from "react-icons/si";
import { FaArrowUpRightFromSquare } from "react-icons/fa6";
import "./about.css"
import { FaMagic, FaHatWizard } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

/* ─── DATA ─────────────────────────────────────────────── */
const services = [
  { Icon: SiBlockchaindotcom, title: "Blockchain Dev",    id: "blockchain-smart-contracts",  sub: "Full-cycle dApp & protocol engineering across EVM and non-EVM chains." },
  { Icon: FaShieldAlt,      title: "Smart Contract Audit",id: "blockchain-smart-contracts", sub: "Formal verification, fuzz testing and manual review to eliminate exploits." },
  { Icon: FaLink,           title: "Cross-chain Integration",id: "blockchain-smart-contracts",  sub: "Bridges, messaging layers and multi-chain UX that just works." },
  { Icon: FaBrain,          title: "AI Automation",   id: "ai-machine-learning", sub: "Custom LLM pipelines, agents and intelligent process automation." },
  { Icon: FaGlobe,          title: "Web Applications", id: "web-development",sub: "Performant, pixel-perfect products engineered for scale." },
  { Icon: FaMobileAlt,      title: "Mobile Apps",  id: "application-development",sub: "Native and cross-platform mobile built for performance and delight." },
  { Icon: FaChartBar,       title: "ux-ui-design",  id: "ux-ui-design",sub: "Crafting user-centric interfaces and experiences to enhance usability and engagement." },
]; 
const timeline = [
  {
    year: "2023",
    title: "Foundation",
    desc: "The company was founded with a vision to deliver modern, scalable, and high-quality digital solutions for startups and enterprises."
  },
  {
    year: "2024",
    title: "Blockchain Development Journey",
    desc: "Started working on blockchain projects, building strong expertise in smart contracts, Web3 integration, and decentralized applications."
  },
  {
    year: "2025",
    title: "Expansion to Large-Scale Projects",
    desc: "Worked with larger blockchain networks and expanded into web applications, business platforms, and eCommerce development for multiple clients."
  },
  {
    year: "2026",
    title: "AI, Advanced Technology & Product Launch",
    desc: "Now focused on AI, automation, and advanced technologies, while also successfully launching our first product and working on innovative solutions."
  }
];


const values = [
  { title: "Transparency",   desc: "No jargon, no hidden costs — honest collaboration at every stage." },
  { title: "Innovation",     desc: "Blending blockchain and AI to craft forward-thinking solutions." },
  { title: "Security First", desc: "Every system ships after rigorous auditing and best-practice hardening." },
  { title: "Scalability",    desc: "Architected for growth — day one to year five without breaking a sweat." },
];

/* ─── MOTION ───────────────────────────────────────────── */
const fadeUp   = { hidden: { opacity: 0, y: 28 }, show: { opacity: 1, y: 0, transition: { duration: 0.5 } } };
const fadeLeft = { hidden: { opacity: 0, x: -28 }, show: { opacity: 1, x: 0, transition: { duration: 0.5 } } };
const stagger  = { hidden: {}, show: { transition: { staggerChildren: 0.09 } } };

/* ─── PAGE ─────────────────────────────────────────────── */
export default function AboutPage() {
  const heroRef = useRef(null);
  const { scrollYProgress } = useScroll({ target: heroRef, offset: ["start start", "end start"] });
  const bgTextY = useTransform(scrollYProgress, [0, 1], [0, -100]);

  // Scroll to top when this page mounts

const navigate=useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div style={{ fontFamily: "'Sora', sans-serif", background: "#f4f3ef", color: "#111", overflowX: "hidden" }}>
   

      {/* ═══ HERO - Lighter theme ═══════════════════════════ */}
      <div className="hero" ref={heroRef}>
        <motion.div className="hero-bg-word" style={{ y: bgTextY }}>
          CHAIN MAGICIAN
        </motion.div>

        <div className="hero-content">
  <div className="hero-content-inner">
    <motion.div variants={stagger} initial="hidden" animate="show" className="hero-text">
      <motion.div variants={fadeUp} className="hero-eyebrow">
        <span className="hero-eyebrow-line" />
        About Us — Est. 2018
      </motion.div>

      <motion.h1 variants={fadeUp} className="hero-title">
        <span className="stroke">We Build</span><br />
        <span className="accent">Digital</span><br />
        Futures
      </motion.h1>
    </motion.div>

    {/* Right side image */}
    <motion.div 
      initial={{ opacity: 0, scale: 0.95, x: 30 }}
      animate={{ opacity: 1, scale: 1, x: 0 }}
      transition={{ duration: 0.7, delay: 0.3 }}
      className="hero-image-wrapper"
    >
      <div style={{
        overflow: 'hidden',
        borderRadius: '24px',
      }}>
        <img 
          src="./img/world.png" 
          alt="Digital Innovation"
          style={{
            width: '100%',
            height: 'auto',
            display: 'block',
            objectFit: 'cover',
            aspectRatio: '4/3',
          }}
        />
      </div>
    </motion.div>
  </div>
</div>
        <div className="hero-foot">
          <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.5, duration: 0.55 }}>
            <p className="hero-desc">
              A modern technology company delivering blockchain, AI-powered software,
              and high-performance digital products for startups and enterprises worldwide.
            </p>
            <div className="hero-cta">
              <a
                href="https://wa.me/916393561379?text=Hello%20I'm%20looking%20for%20software%20development%20services.%20Please%20share%20details."
                className="btn-g"
                target="_blank"
                rel="noopener noreferrer"
              >
                Start a Project <FaArrowRight />
              </a>
              <a href="#services" className="btn-wghost">Our Services</a>
            </div>
          </motion.div>

          <motion.div
            className="hero-stats-row"
            variants={stagger} initial="hidden" animate="show"
          >
            {[
              { v: "500", s: "+", l: "Projects\nDelivered" },
              { v: "120",  s: "+", l: "Happy\nClients" },
              { v: "3",   s: "yr+", l: "Years\nExperience" },
              { v: "30",  s: "+", l: "Team\nMembers" },
            ].map((s, i) => (
              <motion.div key={i} variants={fadeLeft} className="hstat">
                <div className="hstat-num">{s.v}<sup>{s.s}</sup></div>
                <div className="hstat-lbl" style={{ whiteSpace: "pre-line" }}>{s.l}</div>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </div>

      {/* ═══ TICKER ════════════════════════════════════════════ */}
      <div className="ticker">
        <div className="ticker-track">
          {Array(4).fill(["Blockchain Dev","Smart Contract Audit","AI Automation","Cross-chain","Web3 Products","DeFi","Mobile Apps"]).flat().map((t, i) => (
            <span key={i} className="tick-item">{t} <span className="tick-dot" /></span>
          ))}
        </div>
      </div>

      {/* ═══ WHO WE ARE ════════════════════════════════════════ */}
      <div style={{ background: "#fff", borderTop: "1px solid var(--border)" }}>
        <div className="wrap">
          <motion.div variants={stagger} initial="hidden" whileInView="show" viewport={{ once: true }} className="about-split">
            <div>
              <motion.div variants={fadeUp} className="s-label">Who We Are</motion.div>
              <motion.h2 variants={fadeUp} className="dh" style={{ marginBottom: 28 }}>
                Built to push<br /><em>boundaries</em>
              </motion.h2>
              <motion.p variants={fadeUp} className="body-txt">
                Chain Magician Lab is a modern technology company focused on delivering
                innovative and scalable digital solutions. We specialize in blockchain
                development, AI-powered software, and high-performance digital products
                for businesses worldwide.
              </motion.p>
              <motion.p variants={fadeUp} className="body-txt">
                From early-stage startups to established enterprises, we partner with
                ambitious teams to turn complex ideas into production-ready systems —
                built to last, built to scale.
              </motion.p>
              <motion.div variants={stagger} className="checks">
                {["End-to-end blockchain development","Smart contract audit & security","Cross-chain integration expertise","AI-powered automation solutions"].map((f, i) => (
                  <motion.div key={i} variants={fadeUp} className="check-row">
                    <FaCheckCircle className="ci" /> {f}
                  </motion.div>
                ))}
              </motion.div>
            </div>

            <motion.div variants={stagger} className="num-list">
              {[
                { n:"500", s:"+",  l:"Projects Delivered Globally" },
                { n:"120",  s:"+",  l:"Happy Clients Across 20+ Countries" },
                { n:"3",   s:"yr+", l:"Years of Deep Technical Experience" },
                { n:"30", s:"+",  l:"Technologies We Work" },
              ].map((e, i) => (
                <motion.div key={i} variants={fadeUp} className="num-entry">
                  <div className="num-big">{e.n}<sup>{e.s}</sup></div>
                  <div className="num-lbl">{e.l}</div>
                </motion.div>
              ))}
            </motion.div>
          </motion.div>
        </div>
      </div>

      {/* ═══ SERVICES ══════════════════════════════════════════ */}
      <div className="svc-bg" id="services">
        <div className="wrap">
          <div className="svc-head">
            <div>
              <div className="s-label" style={{ color:"var(--g)" }}>What We Do</div>
              <h2 className="dh light" style={{ marginTop: 10 }}>Our Core<br /><em>Services</em></h2>
            </div>
            <p className="svc-sub">Seven disciplines. One team. Everything your Web3 product needs to ship and scale.</p>
          </div>

          <motion.div variants={stagger} initial="hidden" whileInView="show" viewport={{ once: true }} className="svc-table">
            {services.map(({ Icon, title, sub, id }, i) => (
              <motion.div
                key={i}
                variants={fadeUp}
                className="svc-row"
                style={{ cursor: "pointer" }}
                onClick={() => navigate(`/service/${id}`)}
              >
                <span className="svc-idx">0{i + 1}</span>
                <span className="svc-icon-w"><Icon /></span>
                <span className="svc-title">{title}</span>
                <span className="svc-sub-text">{sub}</span>
                <span className="svc-arrow"><FaArrowUpRightFromSquare /></span>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </div>

      {/* ═══ TIMELINE ══════════════════════════════════════════ */}
      <div className="tl-bg">
        <div className="wrap">
          <div className="tl-grid">
            <div className="tl-sticky">
              <motion.div initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }} transition={{ duration: 0.6 }}>
                <div className="tl-ghost">Our<br />Story</div>
                <div className="s-label">Timeline</div>
                <h2 className="dh" style={{ fontSize: "clamp(28px,3vw,40px)" }}>
                  Six years<br />of <em>building</em>
                </h2>
              </motion.div>
            </div>
            <motion.div variants={stagger} initial="hidden" whileInView="show" viewport={{ once: true }} className="tl-rows">
              {timeline.map((t, i) => (
                <motion.div key={i} variants={fadeUp} className="tl-row">
                  <div className="tl-yr">{t.year}</div>
                  <div>
                    <div className="tl-t">{t.title}</div>
                    <div className="tl-d">{t.desc}</div>
                  </div>
                </motion.div>
              ))}
            </motion.div>
          </div>
        </div>
      </div>

      {/* ═══ VALUES ════════════════════════════════════════════ */}
      <div className="val-bg">
        <div className="wrap">
          <div className="val-head">
            <div>
              <div className="s-label">Core Values</div>
              <h2 className="dh" style={{ marginTop: 10 }}>What We<br /><em>Stand For</em></h2>
            </div>
            <p className="val-sub">Every decision traces back to four principles baked into how we work, hire, and ship.</p>
          </div>
          <motion.div variants={stagger} initial="hidden" whileInView="show" viewport={{ once: true }} className="val-grid">
            {values.map((v, i) => (
              <motion.div key={i} variants={fadeUp} className="val-cell">
                <div className="val-n">0{i+1}</div>
                <div className="val-title">{v.title}</div>
                <div className="val-desc">{v.desc}</div>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </div>

      {/* ═══ REDESIGNED TEAM ═════════════════════════════════ */}
<div className="team-bg">
  <div className="wrap">
    <motion.div variants={stagger} initial="hidden" whileInView="show" viewport={{ once: true }}>
      <motion.div variants={fadeUp} className="s-label">The Team</motion.div>
      <motion.h2 variants={fadeUp} className="dh">
        The Minds Behind<br /><em>The Magic</em>
      </motion.h2>
    </motion.div>
    
    <motion.div 
      variants={stagger} 
      initial="hidden" 
      whileInView="show" 
      viewport={{ once: true }}
      style={{
        marginTop: '60px',
        border: '1px solid var(--border)',
        borderRadius: '14px',
        overflow: 'hidden',
        background: '#fff',
        position: 'relative'
      }}
    >
      <motion.div 
        variants={fadeUp}
        style={{
          padding: '40px 10px',
          textAlign: 'center',
          position: 'relative',
          background: '#fff'
        }}
      >
        {/* Decorative ghost text - matching your hero style */}
        <div style={{
  position: 'absolute',
  bottom: '20px',
  right: '30px',
  fontFamily: "'Cormorant Garamond', serif",
  fontSize: '120px',
  fontWeight: 700,
  lineHeight: '.85',
  letterSpacing: '-.05em',
  color: 'transparent',
  WebkitTextStroke: '1.5px var(--border)',
  userSelect: 'none',
  pointerEvents: 'none',
  opacity: 0.5
}}>
  TEAM
</div>

<div style={{
  fontSize: '64px',
  marginBottom: '32px',
  color: 'var(--g)',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '20px',
  padding: '20px 40px',
  border: '2px dashed var(--border)',
  borderRadius: '100px',
  background: 'rgba(38,189,25,0.02)'
}}>
  <FaMagic style={{ fontSize: '48px' }} />
  <FaHatWizard style={{ fontSize: '48px' }} />
</div>
        
        <div style={{
          fontSize: 'clamp(28px, 4vw, 38px)',
          fontWeight: 700,
          color: 'var(--ink)',
          marginBottom: '20px',
          fontFamily: "'Cormorant Garamond', serif",
          letterSpacing: '-.02em'
        }}>
          The curtain rises soon
        </div>
        
        <div style={{
          fontSize: '17px',
          color: '#666',
          lineHeight: '1.8',
          maxWidth: '500px',
          margin: '0 auto',
          position: 'relative',
          zIndex: 2
        }}>
          We're hand-picking the finest minds in blockchain engineering, 
          AI research, and security architecture. 
          <span style={{ color: 'var(--g)', fontWeight: 600, display: 'block', marginTop: '16px' }}>
            Prepare for the reveal.
          </span>
        </div>
        
        {/* Bottom green line animation - matching your values */}
        <div style={{
          position: 'absolute',
          left: 0,
          bottom: 0,
          right: 0,
          height: '4px',
          background: 'var(--g)',
          transform: 'scaleX(0.3)',
          transformOrigin: 'center',
          transition: 'transform .4s ease'
        }}
        onMouseEnter={(e) => e.currentTarget.style.transform = 'scaleX(1)'}
        onMouseLeave={(e) => e.currentTarget.style.transform = 'scaleX(0.3)'}
        />
      </motion.div>
    </motion.div>
  </div>
</div>
      {/* ═══ CTA ═══════════════════════════════════════════════ */}
      <div className="cta-bg" id="contact">
        <div className="cta-inner">
          <motion.h2 className="cta-h"
            initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }} transition={{ duration: 0.58 }}
          >
            Ready to build<br />something <em>great?</em>
          </motion.h2>
          <motion.div className="cta-btns"
            initial={{ opacity: 0 }} whileInView={{ opacity: 1 }}
            viewport={{ once: true }} transition={{ delay: 0.2, duration: 0.5 }}
          >
            <a href="connnect@chainmagicianlab.com" className="btn-g">Get in Touch <FaArrowRight /></a>
            <button
              type="button"
              className="btn-dark"
              style={{ borderColor: "rgba(255,255,255,.18)", color: "rgba(255,255,255,.55)" }}
              onClick={() => {
                navigate('/work');
              }}
            >
              How We Work
            </button>
          </motion.div>
        </div>
      </div>
    </div>
  );
}